// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const readConsentApiMcpOauthConsentGetParamsRequestMax = 4096;

export const ReadConsentApiMcpOauthConsentGetParams = zod.object({
  "request": zod.string().min(1).max(readConsentApiMcpOauthConsentGetParamsRequestMax)
})

export type ReadConsentApiMcpOauthConsentGetParams = zod.input<typeof ReadConsentApiMcpOauthConsentGetParams>;
export type ReadConsentApiMcpOauthConsentGetParamsOutput = zod.output<typeof ReadConsentApiMcpOauthConsentGetParams>;
